module.exports = __webpack_public_path__ + "img/footerbg.79738b60.png";